import { Box, Button, Checkbox, Divider, FormControl, InputLabel, ListItemText, MenuItem, Select, Stack, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { InvokeAPI } from "../../apis/API";
import { getQuestionMgmtBase } from "../../config/apiBase";
import AsyncButton from "../../components/common/AsyncButton";

const GenerateQuestions = () => {
    const [queryData, setQueryData] = useState({
        context: "",
        subject: "",
        class: "",
        kind: "qa",
        withImage: false,
        topic: "",
        level: "easy",
        questionData: {
            "QuestionInfo": []
        },
    })

    //const [questionData, setQuestionData] = useState({})

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target
        if (name === "kind" && value !== "qa") {
            setQueryData({ ...queryData, [name]: value, ["withImage"]: false })
        } else {
            setQueryData({ ...queryData, [name]: value })
        }

    }

    const handleImageSelect = (e) => {
        //e.preventDefault();
        setQueryData({ ...queryData, ["withImage"]: e.target.checked })
    }

    const handleGenerate = async () => {
        console.log(queryData)
        //setQuestionData({})
        const respone = await InvokeAPI(`${getQuestionMgmtBase()}/v1/question/generate`,
            {
                "Context": queryData.context,
                "Class": queryData.class,
                "Subject": queryData.subject,
                "Topic": queryData.topic,
                "Level": queryData.level,
                "Kind": queryData.kind,
                "Image": queryData.withImage,
            },
            'POST',
            {},
            false)
        console.log(respone.response)
        if (respone.response["Questions"] && respone.response["Questions"][0]) {
            //setQuestionData(respone.response["Questions"][0])
            setQueryData({ ...queryData, "questionData": respone.response["Questions"][0] })
        }
    }

    const handleQuestionCange = (index, value) => {
        var newData = queryData.questionData
        newData["QuestionInfo"][index].Question = value
        setQueryData({ ...queryData, "questionData": newData })
    }
    const handleAnswerCange = (index, value) => {
        var newData = queryData.questionData
        newData["QuestionInfo"][index].Answer = value
        setQueryData({ ...queryData, "questionData": newData })
    }
    const handleSolutionCange = (index, value) => {
        var newData = queryData.questionData
        newData["QuestionInfo"][index].Solution = value
        setQueryData({ ...queryData, "questionData": newData })
    }
    const handleAdd = async (aindex) => {
        //Make API call to createQuestion
        let meta = ""
        let metaType = ""
        let questionInfo = []
        if (queryData.kind === "passage" || queryData.withImage === true) {
            meta = queryData.questionData["Meta"]
            metaType = queryData.questionData["MetaType"]
            questionInfo = queryData.questionData["QuestionInfo"]
        } else {
            questionInfo = [queryData.questionData["QuestionInfo"][aindex]]
        }

        const response = await InvokeAPI(`${getQuestionMgmtBase()}/v1/question/create`,
            {
                "Qclass": queryData.class,
                "Qsubject": queryData.subject,
                "Qcategory": queryData.topic,
                "Qlevel": queryData.level,
                "Qtype": queryData.kind,
                "Questions": [{
                    "Meta": meta,
                    "MetaType": metaType,
                    "QuestionInfo": questionInfo,
                }]
            },
            'POST',
            {},
            false)
        console.log(response)
        //Remove the question from the list
        setQueryData({ ...queryData, "questionData": {} })
        if (queryData.kind === "qa" || queryData.kind === "mcq") {
            let newData = { "QuestionInfo": [] }
            for (let index = 0; index < queryData.questionData["QuestionInfo"].length; index++) {
                //console.log(index)
                if (index === aindex) {
                    continue
                }
                newData["QuestionInfo"].push(queryData.questionData["QuestionInfo"][index])
                    
                    /*{"Question": queryData.questionData["QuestionInfo"][index]["Question"],
                    "Answer": queryData.questionData["QuestionInfo"][index]["Answer"],
                    "Options": queryData.questionData["QuestionInfo"][index]["Options"],
                    "Solution": queryData.questionData["QuestionInfo"][index]["Solution"],
                    "Feedback": queryData.questionData["QuestionInfo"][index]["Feedback"],}*/
                
                //newData["QuestionInfo"].push(queryData.questionData["QuestionInfo"][index]);
                //console.log(queryData.questionData["QuestionInfo"][index])
            }
            //console.log(newData)
            setQueryData({ ...queryData, "questionData": newData })
        }

    }

    function handleRemove(rindex) {
        //console.log(rindex)
        setQueryData({ ...queryData, "questionData": {} })
        let newData = { "QuestionInfo": [] }
        for (let index = 0; index < queryData.questionData["QuestionInfo"].length; index++) {
            //console.log(index)
            if (index === rindex) {
                continue
            }
            newData["QuestionInfo"].push({
                "Question": queryData.questionData["QuestionInfo"][index]["Question"],
                "Answer": queryData.questionData["QuestionInfo"][index]["Answer"],
                "Options": queryData.questionData["QuestionInfo"][index]["Options"],
                "Solution": queryData.questionData["QuestionInfo"][index]["Solution"],
            })
            //newData["QuestionInfo"].push(queryData.questionData["QuestionInfo"][index]);
            //console.log(queryData.questionData["QuestionInfo"][index])
        }
        //console.log(newData)

        setQueryData({ ...queryData, "questionData": newData })
    }

    /*
    console.log(queryData.questionData)
    console.log(queryData.questionData["Meta"])
    console.log(queryData.questionData["QuestionInfo"])
    */

    return (
        <Box sx={{ paddingBottom: '80px' }}>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ margin: "20px" }}>
                <Stack >
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <TextField
                            label="class"
                            name="class"
                            required
                            value={queryData.class}
                            onChange={handleChange}
                            sx={{ margin: "20px" }}
                        />
                        <TextField
                            label="subject"
                            name="subject"
                            required
                            value={queryData.subject}
                            onChange={handleChange}
                            sx={{ margin: "20px" }}
                        />
                        <TextField
                            label="topic"
                            name="topic"
                            required
                            value={queryData.topic}
                            onChange={handleChange}
                            sx={{ margin: "20px" }}
                        />
                    </Box>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <FormControl sx={{ margin: "20px" }}>
                            <InputLabel>Level</InputLabel>
                            <Select
                                name="level"
                                value={queryData.level}
                                onChange={handleChange}
                                autoWidth
                                label="Select Level"
                            >
                                <MenuItem value="easy">Easy</MenuItem>
                                <MenuItem value="intermediate">Intermediate</MenuItem>
                                <MenuItem value="advanced">Advanced</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl sx={{ margin: "20px" }}>
                            <InputLabel>Type</InputLabel>
                            <Select
                                name="kind"
                                value={queryData.kind}
                                onChange={handleChange}
                                autoWidth
                                label="Select Type"
                            >
                                <MenuItem value="qa">Q&A</MenuItem>
                                <MenuItem value="mcq">MCQ</MenuItem>
                                <MenuItem value="passage">Passage</MenuItem>
                            </Select>
                        </FormControl>
                        {queryData.kind === "qa" &&
                            <>
                                <Checkbox sx={{ margin: "20px" }} id="withImage" checked={queryData.withImage} onChange={handleImageSelect} />
                                With Image
                            </>
                        }
                    </Box>
                    <TextField
                        label="context"
                        name="context"
                        multiline
                        fullWidth
                        required
                        value={queryData.context}
                        onChange={handleChange}
                        sx={{ margin: "20px" }}
                    />
                    <Box display="flex" justifyContent="center" alignItems="center" sx={{ margin: "20px" }}>
                        <AsyncButton type="submit" variant="contained" color="primary" onClick={handleGenerate}>
                            Sumbit
                        </AsyncButton>
                    </Box>
                </Stack>
            </Box>
            <Divider sx={{ borderColor: "black" }}></Divider>
            <Stack>
                {queryData.questionData && queryData.questionData["Meta"] !== undefined &&
                    <>
                        {queryData.questionData["Meta"] !== "" && queryData.questionData["MetaType"] === "" &&
                            <Box display="flex" sx={{ margin: "20px" }}>
                                <TextField
                                    label="Passage"
                                    defaultValue={queryData.questionData["Meta"]}
                                    multiline
                                    fullWidth
                                />
                            </Box>
                        }
                        {queryData.questionData["Meta"] !== "" && queryData.questionData["MetaType"] !== "" &&
                            <Box display="flex" sx={{ margin: "20px" }}>
                                <img src={"data:" + queryData.questionData["MetaType"] + ";base64," + queryData.questionData["Meta"]} />
                            </Box>
                        }
                    </>
                }
                {
                    queryData.questionData && queryData.questionData["QuestionInfo"] !== undefined && queryData.questionData["QuestionInfo"].map((row, index) => (
                        <Stack>
                            <h3> {index + 1}.</h3>
                            <Box display="flex" sx={{ margin: "20px" }}>
                                <TextField
                                    label="Quesiton"
                                    value={row.Question}
                                    multiline
                                    id={index}
                                    key={index}
                                    fullWidth
                                    onChange={(e) => {
                                        handleQuestionCange(index, e.target.value)
                                    }}
                                />
                            </Box>
                            {row.Options && row.Options.map((oRow, oIndex) => (
                                <>
                                    <Box display="flex" sx={{ margin: "20px" }}>
                                        <TextField
                                            label="Option"
                                            value={oRow}
                                            multiline
                                            id={"option" + oIndex}
                                            key={"option" + oIndex}
                                            fullWidth
                                            onChange={(e) => {
                                                handleAnswerCange(oIndex, e.target.value)
                                            }}
                                        />
                                    </Box>
                                </>
                            ))}
                            <Box display="flex" sx={{ margin: "20px" }}>
                                <TextField
                                    label="Answer"
                                    value={row.Answer}
                                    multiline
                                    id={index}
                                    key={index}
                                    fullWidth
                                    onChange={(e) => {
                                        handleAnswerCange(index, e.target.value)
                                    }}
                                />
                            </Box>
                            <Box display="flex" sx={{ margin: "20px" }}>
                                <TextField
                                    label="Solution"
                                    value={row.Solution}
                                    multiline
                                    id={index}
                                    key={index}
                                    fullWidth
                                    onChange={(e) => {
                                        handleSolutionCange(index, e.target.value)
                                    }}
                                />
                            </Box>
                            {(queryData.kind === "qa" || queryData.kind === "mcq") &&
                                <Box display="flex" justifyContent="center" alignItems="center" sx={{ margin: "20px" }}>
                                    <AsyncButton type="submit" variant="contained" color="success" onClick={async (e) => { await handleAdd(index) }}>
                                        Add
                                    </AsyncButton>
                                    &nbsp;
                                    <Button type="submit" variant="outlined" color="error" onClick={(e) => { e.preventDefault(); handleRemove(index) }}>
                                        Remove
                                    </Button>
                                </Box>
                            }

                            <Divider sx={{ borderColor: "blue" }}></Divider>

                        </Stack>
                    )
                    )
                }
                {
                    (queryData.kind === "passage" || queryData.withImage === true) && queryData.questionData && queryData.questionData["QuestionInfo"] !== undefined && queryData.questionData["QuestionInfo"].length != 0 &&
                    <Box display="flex" justifyContent="center" alignItems="center" sx={{ margin: "20px" }}>
                        <AsyncButton type="submit" variant="contained" color="success" onClick={async (e) => { await handleAdd(-1) }}>
                            Add
                        </AsyncButton>
                    </Box>
                }
            </Stack>
        </Box>
    )
}

export default GenerateQuestions;
